import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import RecipeRow, { RecipeCard } from "./RecipeRow";
import useLoginCheck from "../util/useLoginCheck";
import CreateRecipe from "./CreateRecipe";
import Spinner from "../util/Spinner";
import { fetchRecipes } from "../slice/recipeSlice";

const RecipeTable = () => {
  const dispatch = useDispatch();
  const { recipes, isLoading, error } = useSelector((state) => {
    return state?.recipes;
  });
  const location = useLocation();
  const [isCreateRecipeOpen, setIsCreateRecipeOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();

  useLoginCheck();

  useEffect(() => {
    const refreshParam = searchParams.get("refresh") === "true";
    console.log("refreshParam is ", refreshParam);
    if (refreshParam) {
      console.log("refreshing recipes...");
      dispatch(fetchRecipes());
      navigate(window.location.pathname, { replace: true }); // clear query string
    } else {
      console.log("fetching recipes...");
      dispatch(fetchRecipes());
    }
  }, [dispatch, location.search]);

  const toggleCreateRecipe = () => {
    setIsCreateRecipeOpen(!isCreateRecipeOpen);
  };

  const handleSearchTextChange = (text) => {
    console.log("Search text: ", text);
    setSearchText(text);
  };

  const recipeNameMatchesSearch = (recipe) => {
    return searchText
      ? recipe?.name?.toLowerCase().includes(searchText.toLowerCase())
      : true;
  };

  const createGroceryList = () => {
    navigate("/grocerylist", { state: { recipes } });
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      {isLoading ? (
        <Spinner />
      ) : recipes && recipes.length > 0 ? (
        <div>
          <div className="flex flex-wrap justify-end gap-2 mb-4">
            <button className="btn-secondary" onClick={createGroceryList}>
              Grocery list
            </button>
            <button className="btn-primary" onClick={setIsCreateRecipeOpen}>
              New recipe
            </button>
            {isCreateRecipeOpen && (
              <CreateRecipe closePopup={toggleCreateRecipe} />
            )}
          </div>
          <input
            type="text"
            placeholder="Search"
            className="w-full border border-stone-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-teal-600"
            value={searchText}
            onChange={(e) => handleSearchTextChange(e.target.value)}
          ></input>
          <table className="hidden md:table w-full card">
            <thead>
              <tr className="text-left text-sm text-stone-500 border-b border-stone-200">
                <th className="px-3 py-2 font-medium">Name</th>
                <th className="px-3 py-2 font-medium">Calories</th>
                <th className="px-3 py-2 font-medium">From the Kitchen Of</th>
                <th className="px-3 py-2 font-medium">Total Time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-200">
              {recipes?.filter(recipeNameMatchesSearch).map((recipe) => {
                return <RecipeRow key={recipe.sid} recipe={recipe}></RecipeRow>;
              })}
            </tbody>
          </table>
          <ul className="md:hidden space-y-3">
            {recipes?.filter(recipeNameMatchesSearch).map((recipe) => (
              <RecipeCard key={recipe.sid} recipe={recipe} />
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-stone-500">No recipes entered</p>
      )}
    </div>
  );
};
export default RecipeTable;
